import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { ExpensesApi } from '../expenses.api';

export const useGetRecalculationsTotalExpanses = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: ExpensesApi.getExpensesRecalculationsByCategory,
  });
};
